import { z } from "zod";
import { Id, Timestamp } from "./common.js";

export const Username = z
  .string()
  .trim()
  .toLowerCase()
  .min(3)
  .max(32)
  .regex(/^[a-z0-9._-]+$/, "Only letters, digits, dot, dash and underscore");

// Upper bound keeps Argon2 hashing cost bounded (DoS protection).
export const NewPassword = z.string().min(12).max(256);
const ExistingPassword = z.string().min(1).max(256);

export const Email = z.email().max(254).toLowerCase();

export const SetupRequest = z.object({
  email: Email,
  username: Username,
  password: NewPassword,
  setupToken: z.string().max(256).optional(),
});
export type SetupRequest = z.infer<typeof SetupRequest>;

export const LoginRequest = z.object({
  username: Username,
  password: ExistingPassword,
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const User = z.object({
  id: Id,
  username: z.string(),
  email: z.string(),
  createdAt: Timestamp,
});
export type User = z.infer<typeof User>;

export const AuthStatus = z.object({
  setupRequired: z.boolean(),
  user: User.nullable(),
  /** spec07: the server's version, for signed-in users only (never on public responses). */
  version: z.string().optional(),
});
export type AuthStatus = z.infer<typeof AuthStatus>;

/** Response of Better Auth's sign-in endpoint (only the fields clients rely on). */
export const SignInResponse = z.object({
  user: z.object({ id: Id, username: z.string(), email: z.string(), createdAt: Timestamp }),
});
export type SignInResponse = z.infer<typeof SignInResponse>;

export const CsrfTokenResponse = z.object({ token: z.string() });
export type CsrfTokenResponse = z.infer<typeof CsrfTokenResponse>;
